module.exports = __webpack_public_path__ + "img/file_image.e5f108b5.svg";